export const localizationStringsIt = {
  scan_the_front_side: 'Scansiona il fronte del documento',
  scan_data_page: 'Scansiona la pagina dei dati del documento',
  scan_top_page: 'Scansiona la pagina superiore',
  scan_left_page: 'Scansiona la pagina sinistra',
  scan_right_page: 'Scansiona la pagina destra',
  flip_document: 'Gira il documento',
  wrong_top: 'Sposta verso la pagina superiore',
  wrong_left: 'Sposta verso la pagina sinistra',
  wrong_right: 'Sposta verso la pagina destra',
  flip_to_back_side: 'Gira sul retro',
  move_top: 'Spostati verso l’alto',
  move_left: 'Spostati verso sinistra',
  move_right: 'Spostati verso destra',
  scan_the_back_side: 'Scansiona il retro del documento',
  scan_the_barcode: 'Scansiona il codice a barre',
  move_closer: 'Avvicina il documento',
  move_farther: 'Allontana il documento',
  camera_angle_too_steep: 'Mantieni il documento parallelo al telefono',
  face_photo_not_fully_visible:
    'Tieni la foto del volto completamente visibile',
  document_too_close_to_edge: 'Allontana il documento dal bordo',
  blur_detected: 'Tieni fermi il documento e il telefono',
  glare_detected: 'Inclina o sposta il documento per eliminare i riflessi',
  occluded: 'Tieni il documento completamente visibile',
  too_dark: 'Spostati in un luogo più luminoso',
  too_bright: 'Spostati in un luogo meno luminoso',
  scan_unsuccessful: 'Scansione non riuscita',
  scan_unsuccessful_details: 'Impossibile leggere il documento. Riprova.',
  error_occurred: 'Errore verificato',
  sdk_initialization_error: 'Errore durante l’inizializzazione dell’SDK',
  sdk_initialization_error_details:
    "Si è verificato un errore durante l'inizializzazione dell'SDK BlinkID.",
  camera_error: 'Errore della fotocamera',
  camera_permission_denied:
    "Accesso alla fotocamera negato. Si prega di consentire l'accesso alla fotocamera e riprovare.",
  scan_time_exceeded: 'Tempo di scansione superato',
  scan_taking_longer_hint:
    'Il processo di scansione sta richiedendo più tempo del previsto. Assicurati che il documento sia ben illuminato, a fuoco e correttamente posizionato nell’inquadratura della fotocamera.',
  document_not_supported: 'Documento non supportato',
  try_different_document: 'Provare un altro documento',
  document_not_supported_hint:
    'Il documento che stai tentando di scansionare non è supportato da questa applicazione. Prova a scansionare un documento diverso.',
  document_not_recognized: 'Documento non riconosciuto',
  document_not_recognized_details:
    'Scansiona il fronte di un documento supportato.',
  document_filtered: 'Documento non accettato',
  label_from: 'da',
  onboarding_modal_title: 'Tieni tutti i dettagli visibili',
  onboarding_modal_details:
    'Assicurati che il documento sia ben illuminato. Tutti i campi devono essere visibili sullo schermo.',
  onboarding_modal_btn: 'Avvia scansione',
  help_modal_title_1: 'Tieni tutti i campi visibili',
  help_modal_details_1:
    'Non coprire alcuna parte del documento con il dito, incluse le righe in basso. Fai attenzione ai riflessi dell’ologramma.',
  help_modal_title_2: 'Evita la luce diretta',
  help_modal_details_2:
    'La luce diretta può creare riflessi che rendono il documento illeggibile. Se i dati non sono leggibili, la fotocamera non può leggerli.',
  help_modal_title_3: 'Rimani fermo durante la scansione',
  help_modal_details_3:
    'Cerca di tenere fermi il telefono e il documento durante la scansione.',
  help_modal_back_btn: 'Indietro',
  help_modal_next_btn: 'Avanti',
  help_modal_done_btn: 'Fine',
  help_aria_label: 'Aiuto',
  help_tooltip: 'Hai bisogno di aiuto?',
  alert_retry_btn: 'Riprova',
  alert_cancel_btn: 'Annulla',
  screen_photo_error:
    'Non fotografare uno schermo. Utilizza il documento originale.',
  glare_photo_error: 'Riflessi rilevati. Evita la luce diretta o i riflessi.',
  copy_or_screenshot_photo_error:
    'Il documento sembra essere una copia o uno screenshot. Utilizza il documento originale.',
  invalid_document_photo_error:
    'Il documento è incompleto, non valido o incoerente. Controllalo di nuovo.',
  front_side_blur_or_glare_error:
    'Il lato anteriore è sfocato, presenta riflessi o non è stato rilevato correttamente.',
  both_sides_required_error:
    'Per questo tipo di documento, entrambi i lati devono essere caricati. Carica il secondo lato.',
  invalid_file_type:
    'Tipo di file non valido. Si prega di caricare un JPG, JPEG o PNG.',
  file_too_large_error: 'Il file è troppo grande. Massimo 5 MB consentiti.',
  scan_successful: 'Scansione riuscita.',
} as const;
